/* Copyright (c) 2019-2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { ReleaseConfiguration } from './base';
import { LoggerConfig, LoggingLevel } from 'crimson';

export const releaseConfiguration: ReleaseConfiguration = {
    production: false
};

export const loggerConfig: LoggerConfig = {
    defaultLoggingLevel: LoggingLevel.Verbose
};
